// MAP CONSTANTS
export const NORTH_AMERICA = 'northamerica';
export const UNITED_STATES = 'unitedstates';
export const CANADA = 'canada';
export const MEXICO = 'mexico';

export const FILTER_ALL = 'viewAll';
export const FILTER_ENG_MAN = 'has-manufacturingDistribution';
export const FILTER_RESEARCH_DEV = 'has-researchDesign';
export const FILTER_DEALERSHIPS = 'has-dealers';
export const FILTER_OFFICES = 'has-corporateOffices';

export const SELECTED_CLASS = 'selected';

// export const DL_API_URI = 'https://staging.ws.disrest.tms.aws.toyota.com/disrest/getAllDealers';
// export const DL_API_KEY = '';

export const BRAND_TOYOTA = 'toyota';
export const BRAND_LEXUS = 'lexus';

export const DOT_OVERRIDES = {
    'USLA': '[[44,65],[50,50],[50,50],[28,35]]',
    'USPR': '[[50,50],[50,50],[50,50],[35,44]]',
};
